/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ui/NG_CLOSE': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<path pid="0" class="cls-1" d="M24.52 1.89L23.11.48 12.5 11.09 1.89.48.48 1.89 11.09 12.5.48 23.11l1.41 1.41L12.5 13.91l10.61 10.61 1.41-1.41L13.91 12.5 24.52 1.89z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/ui/NG_CLOSE.js